<template>
    <div class="overlay active overlay--auth backdrop-blur">
        <div class="wrapper-lightbox" style="max-width: 560px;">
            <div class="close-modal" @click="$emit('close')">
                &times;
            </div>
            <div class="lightbox">
                <div class="p-4 md:py-6 md:px-8">
                    <p class="tx-20 weight-500 opacity-90 m-0">
                        Compartir esta comparación
                    </p>
                </div>
                <hr class="m-0">
                <!-- SHARE FACEBOOK -->
                <ShareNetwork network="facebook" :url="getShareLink()" title="Mi comparación en AutoDeal" description="Esta es mi comparativa AutoDeal" quote="AutoDeal - Comparación de vehículos." :hashtags="getTags()">
                    <div class="share-item flex justify-content-between align-items-center p-4 md:py-5 md:px-8">
                        <div>
                            <img class="mr-2 md:mr-4" width="40px" src="/assets/images/helpers/icon-facebook-circle.svg" alt="">
                            <span>
                                Facebook
                            </span>
                        </div>
                        <div class="underline tx-14 cursor-pointer opacity-70">
                            compartir ahora
                        </div>
                    </div>
                </ShareNetwork>
                <hr class="m-0">
                <!-- SHARE WHATS APP -->
                <ShareNetwork network="whatsApp" :url="getShareLink()" title="Mi comparación en AutoDeal" description="Esta es mi comparativa AutoDeal">
                    <div class="share-item flex justify-content-between align-items-center p-4 md:py-5 md:px-8">
                        <div>
                            <img class="mr-2 md:mr-4" width="40px" src="/assets/images/helpers/icon-whatsapp-circle.svg" alt="">
                            <span>
                                Whatsapp
                            </span>
                        </div>
                        <div class="underline tx-14 cursor-pointer opacity-70">
                            compartir ahora
                        </div>
                    </div>
                </ShareNetwork>
                <hr class="m-0">
                <!-- SHARE TWITTER -->
                <ShareNetwork network="twitter" :url="getShareLink()" title="Mi comparación en AutoDeal" description="Esta es mi comparativa AutoDeal" quote="AutoDeal - Comparación de vehículos." :hashtags="getTags()">
                    <div class="share-item flex justify-content-between align-items-center p-4 md:py-5 md:px-8">
                        <div>
                            <img class="mr-2 md:mr-4" width="40px" src="/assets/images/helpers/icon-twitter-circle.svg" alt="">
                            <span>
                                Twitter
                            </span>
                        </div>
                        <div class="underline tx-14 cursor-pointer opacity-70">
                            compartir ahora
                        </div>
                    </div>
                </ShareNetwork>
                <hr class="m-0">
                <!-- SHARE COPY LINK -->
                <div class="share-item  flex justify-content-between align-items-center p-4 md:py-5 md:px-8 cursor-pointer" @click="CopyClipboard($event)">
                    <div>
                        <img class="mr-2 md:mr-4" width="40px" src="/assets/images/helpers/icon-copy-link-circle.svg" alt="">
                        <span>
                            Copiar Link
                        </span>
                    </div>
                    <div class="underline tx-14 cursor-pointer opacity-70">
                        compartir ahora
                    </div>
                </div>
                <transition name="fade">
                    <div class="alert alert--copied py-2 md:py-3 px-3 md:px-7" v-show="linkCopied">
                        <strong>Link copiado</strong>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

export default {
    props: [
        'product_one',
        'product_two',
        'product_three',
        'share_link'
    ],
    data() {
        return {
            linkCopied: false
        }
    },
    methods: {
        getShareLink() {
            let vm = this;
            var parameters = [];

            if (vm.product_one) {
                parameters.push( 'car_one=' + vm.product_one.id );
            }

            if (vm.product_two) {
                parameters.push( 'car_two=' + vm.product_two.id );
            }

            if (vm.product_three) {
                parameters.push( 'car_three=' + vm.product_three.id );
            }
            return vm.share_link + '?' + parameters.join('&');
        },

        getTags() {

            let vm = this;
            var tags = ['TURN'];
            const regex = /\s/g;

            if (vm.product_one) {
                tags.push( vm.product_one.model.title );
                tags.push( vm.product_one.version );
            }

            if (vm.product_two) {
                tags.push( vm.product_two.model.title );
                tags.push( vm.product_two.version );
            }

            if (vm.product_three) {
                tags.push( vm.product_three.model.title );
                tags.push( vm.product_three.version );
            }
            return tags.join(',').replace(regex,'_');
        },

        CopyClipboard(event) {
            let vm = this;
            event.preventDefault();
            vm.linkCopied = true;
            var tempInput   = document.createElement("input");
            tempInput.style = "position: absolute; left: -1000px; top: -1000px";
            tempInput.value = vm.getShareLink();
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            setTimeout( function(){
                vm.linkCopied = false;
            }, 5000)
        }
    }
}
</script>

<style lang="scss">
    .share-item{
        transition: all 150ms;

        @media screen and (min-width: 1280px){
            &:hover{
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.09);
            }
        }
    }

    .alert--copied {
        border-color: #ffffff;
        background-color: #e6e6e673;
        color: #8c8c8c;
        width: 100%;
        text-align: center;
    }
</style>
